import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NewEditPersonalityComponent } from '../new-edit-personality/new-edit-personality.component';

@Component({
  selector: 'app-add-personality-card',
  standalone: true,
  imports: [CommonModule, FormsModule, MatTooltip, NewEditPersonalityComponent],
  templateUrl: './add-personality-card.component.html',
  styleUrl: './add-personality-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddPersonalityCardComponent {
  isNewEditVisible = false;

  constructor() {}

  onAddPersonalityClick() {
    this.isNewEditVisible = true;
  }
}
